<template>
    <v-app-bar
            app
            color="primary"
            dark
            :max-width="$vuetify.breakpoint.width"
    >
        <v-img max-width="150" src="@/assets/full_logo.png"
               class="hover"
               alt="Sinculis Logo"
               v-if="$store.getters.GET_ROUTE"
               @click="$routerService.goTo('main')"></v-img>
        <v-spacer/>
        <v-btn @click="toggleDrawer" icon>
            <v-icon :size="24" color="#fff">mdi-menu</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
    export default {
        name: "AppBarComponent",
        methods: {
            toggleDrawer() {
                this.$store.dispatch('setDrawer', true);
            }
        }
    }
</script>

<style scoped>

</style>
